
import { GET_SILENCER } from '../../constants/ActionTypes';

export function getSilencer(url, specification) {
  return {
    type: GET_SILENCER,
    request: {
      op: 'post',
      path: `${url}/@silencer`,
      data: specification,
    },
  };
}
